import React from "react";
import { findAllAcademicPartEvent } from "../../_events/academic_parts/find.event";
import { alertError } from "../../_utils/alerts";

export const useAcademicPartAll = () => {

    const [data, setData] = React.useState([]);

    const loadData = () => {
        findAllAcademicPartEvent()
        .then(json => {
            setData(json.list);
        })
        .catch(err => {
            alertError(err.message);
        });
    }

    React.useEffect(() => {
        loadData();
    }, []);

    return { data, loadData };
}